export default __webpack_public_path__ + "7873b3cfd4a59ec3f7a72c72b600641d.png";